jQuery(document).ready(function ($) {
    // convert manu accordian in mobile only 
    function mobileFooterAccordion() {
        $('.sub-menu-child > .mobile-footer-menu-lable').off('click');

        if (window.innerWidth < 750) {
            $('.sub-menu-child > .mobile-footer-menu-lable').on('click', function (e) {
                e.preventDefault();
                var $currentLi = $(this).closest('.sub-menu-child');
                $('.sub-menu-child').not($currentLi).removeClass('open-menu');
                $currentLi.toggleClass('open-menu');
            });
        } else {
            $('.sub-menu-child').removeClass('open-menu');
        }
    }

    mobileFooterAccordion();
    $(window).on('resize', mobileFooterAccordion);


    // ===============================
    // Sticky Skio Plans
    // Optimized + Mobile Smooth
    // ===============================

    const $pickerParent = $('#custom-skio-plans');
    const $picker = $pickerParent.find('.custom-plan-wrapper');
    const $sticky = $('#stickySkio');

    if ($picker.length && $sticky.length) {

        // -------------------------------
        // Spacer (prevents layout jump)
        // -------------------------------

        const lockedHeight = $pickerParent.outerHeight(true);

        const $spacer = $('<div id="skio-spacer"></div>').css({
            height: lockedHeight,
            display: 'none'
        });

        $pickerParent.before($spacer);

        // -------------------------------
        // State guards
        // -------------------------------

        let wasInView = null;
        let spacerState = null;

        // -------------------------------
        // Sticky ATC click
        // -------------------------------

        const bindATC = () => {

            $('#custom-add-to-cart')
                .off('click')
                .on('click', function () {

                    $('.product-form .product-form__submit')
                        .trigger('click');
                });
        };

        // -------------------------------
        // Main logic
        // -------------------------------

        const updateSticky = () => {

            const rect = $pickerParent[0].getBoundingClientRect();

            const inView =
                rect.bottom > 0 &&
                rect.top < window.innerHeight;

            // -------------------------------
            // Move picker only on state change
            // -------------------------------

            if (inView !== wasInView) {

                wasInView = inView;

                // ===============================
                // RETURN TO ORIGINAL POSITION
                // ===============================

                if (inView) {

                    if (!$pickerParent.find('.custom-plan-wrapper').length) {
                        $pickerParent.append($picker);
                    }

                    $pickerParent
                        .find('.custom-plan-wrapper #custom-add-to-cart')
                        .remove();
                    $sticky.empty();
                }

                // ===============================
                // MOVE TO STICKY
                // ===============================

                else {

                    if (!$sticky.find('.custom-plan-wrapper').length) {

                        $sticky.append($picker);
                    }

                    if (!$sticky.find('#custom-add-to-cart').length) {
                        $sticky.find('.custom-plan-wrapper').append(`
                            <button
                                type="button"
                                id="custom-add-to-cart"
                                class="product-form__submit button button--primary mono-regular">
                                <span>Add to cart</span>
                            </button>
                        `);
                        bindATC();
                    }
                }
            }

            // -------------------------------
            // Spacer + animation helper
            // -------------------------------

            if (inView !== spacerState) {

                spacerState = inView;

                if (!inView) {
                    $spacer.show();
                    $sticky.addClass('html-added');

                } else {
                    $spacer.hide();
                    $sticky.removeClass('html-added');
                }
            }
        };

        // -------------------------------
        // Initial run
        // -------------------------------

        updateSticky();

        // -------------------------------
        // Optimized scroll handling
        // -------------------------------

        let ticking = false;

        const handleScroll = () => {

            if (!ticking) {

                requestAnimationFrame(() => {
                    updateSticky();
                    ticking = false;
                });

                ticking = true;
            }
        };

        $(window).on('scroll resize', handleScroll);
    }


    // ===============================
    // PDP Sticky and jump js end
    // ===============================

    $(document)
        .off('click', '#stickySkio .subs-box.selected')
        .on('click', '#stickySkio .subs-box.selected', function () {

            $('#stickySkio').addClass('option-visible');
        });

    $(document)
        .off('change', 'input[name="custom-skio-selling-plan"]')
        .on('change', 'input[name="custom-skio-selling-plan"]', function () {

            $('#stickySkio').removeClass('option-visible');
        });

    const $radios = $('.subs-box input[type="radio"]');

    // handle change selection
    if ($radios) {
        $radios.on('change', function () {
            const $mainwrapper = $(this).closest('.single-sell-plan-box');
            const $wrapper = $(this).closest('.subs-box');
            const planId = $wrapper.data('plan-id');
            const planName = $(this).data('plan-name');

            if ($('input[value="' + planName + '"]').length) {
                $('input[value="' + planName + '"]').trigger('click');
            }

            // update hidden selling plan input
            if ($('#selling-plan-input').length) {
                $('#selling-plan-input').val(planId || '');
            }

            // remove selected class from all
            $('.subs-box').removeClass('selected');
            $('.single-sell-plan-box').removeClass('selected-box');

            // add selected to clicked one
            $wrapper.addClass('selected');
            $mainwrapper.addClass('selected-box');
        });
    }

    // IMPORTANT: apply default selection on load
    const $defaultChecked = $('.subscription-box .subs-box input[type="radio"]:checked');
    if (!$defaultChecked.length) {
        var $radio;
        if ($('.subscription-box .subs-box input[type="radio"]').length > 1) {
            $radio = $('.subscription-box .subs-box input[type="radio"]').eq(0);
        } else {
            $radio = $('.subscription-box .subs-box input[type="radio"]').eq(1);
        }

        if ($radio) $radio.prop('checked', true).trigger('change');
    }

    if ($('header-drawer').length) {
        $('header-drawer').on('click', 'summary', function (e) {
            e.stopPropagation();
        });
    }

    // Atc with selling plan
    function addToCartWithSellingPlan(variantId, quantity, sellingPlanId) {
        $('.rebuy-cart').addClass('loader');
        const data = {
            id: variantId,
            quantity: quantity || 1,
            selling_plan: sellingPlanId
        };

        $.post('/cart/add.js', data)
            .done(function (response) {
                const cart = window.Rebuy?.Cart?.cart;
                if (cart) {
                    cart.items.forEach(item => {
                        const isGift =
                            item.price === 0 &&
                            item.properties?._source === 'Rebuy';

                        if (!isGift && item.quantity > 0 && (!item.selling_plan_allocation || (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan.id != sellingPlanId))) {
                            window.Rebuy.SmartCart.removeItem(item);
                        }
                    });
                }
                var options = $("#product-plans").html();
                var selectBox = '<select\
                aria-label="Subscription delivery frequency"\
                class="rebuy-select muted custom-skio-select"\
            >\
                <optgroup label="Upgrade and Save More">\
                '+ options + '\
                </optgroup>\
            </select>';
                if (!$('div[data-rebuy-component="cart-items"] li .rebuy-cart__flyout-item-subscription').length) {
                    $('div[data-rebuy-component="cart-items"] li').eq($('div[data-rebuy-component="cart-items"] li').length - 1).append('<div class="rebuy-cart__flyout-item-subscription">' + selectBox + '</div>');
                }
                setTimeout(() => {
                    $('.custom-skio-select').val(sellingPlanId);
                    $('.custom-skio-select option[value="' + sellingPlanId + '"]').prop('selected', true);
                    $('.rebuy-cart').removeClass('loader');
                }, 1500);
            })
            .fail(function (error) {
                $('.rebuy-cart').removeClass('loader');
            });
    }

    $(document).on('click', '.convert-to-sub', function () {
        var plan1Id = $('input[data-plan-name="MLS-1M"]').parent().data('plan-id');
        var variantId = meta.product.variants[1].id;

        // Example call
        addToCartWithSellingPlan(variantId, 1, plan1Id);
    });

    $(document).on('change', '.custom-skio-select', function () {
        var plan1Id = $(this).val();
        var variantId = $(this).find('option:selected').data('variant-id');

        // Example call
        addToCartWithSellingPlan(variantId, 1, plan1Id);
    });

    // open only one toggle at a time 
    document.addEventListener("click", function (e) {

        const summary = e.target.closest(".product__accordion summary");
        if (!summary) return;

        const productWrapper = summary.closest(".product");
        if (!productWrapper) return;

        const clickedDetails = summary.closest("details");
        const allDetails = productWrapper.querySelectorAll(".product__accordion details");

        // Prevent native toggle
        e.preventDefault();

        const isAlreadyOpen = clickedDetails.hasAttribute("open");

        // STEP 1: Close everything
        allDetails.forEach((item) => {
            item.removeAttribute("open");
            const s = item.querySelector("summary");
            if (s) s.setAttribute("aria-expanded", "false");
        });
        // STEP 2: If it was closed before → open only this one
        if (!isAlreadyOpen) {
            clickedDetails.setAttribute("open", "true");
            summary.setAttribute("aria-expanded", "true");
        }
    });

    // Changing NAD+ to Superim tag
    const targetRegex = /nad\+/gi;

    function replaceInTextNodes(node) {
        $(node)
            .contents()
            .each(function () {
                if (this.nodeType === 3) {
                    const newText = this.nodeValue.replace(targetRegex, 'NAD<sup>+</sup>');
                    if (newText !== this.nodeValue) {
                        $(this).replaceWith(newText);
                    }
                } else {
                    replaceInTextNodes(this);
                }
            });
    }

    replaceInTextNodes(document.body);
});